/**
 * Form
 */
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
import React, { useState, useRef } from 'react';
import { useFormValue } from './context/Form.context';
import { useChildClones } from './hooks/useChildClones';
// Generates a unique key (used by the reset-method).
var getUniqueKey = function () { return '_' + Math.random().toString(36).substr(2, 9); };
var Form = function (_a) {
    var children = _a.children, _b = _a.method, method = _b === void 0 ? 'post' : _b, _c = _a.action, action = _c === void 0 ? '' : _c, _d = _a.enctype, enctype = _d === void 0 ? 'application/x-www-form-urlencoded' : _d, initialValues = _a.initialValues, className = _a.className, id = _a.id, onChange = _a.onChange, onSubmit = _a.onSubmit, onReset = _a.onReset, sendDataType = _a.sendDataType, defaultSubmit = _a.defaultSubmit, multiStep = _a.multiStep, currentStep = _a.currentStep, getStepFields = _a.getStepFields, defaultFormRef = _a.formRef, dataName = _a.dataName;
    var _e = useState(getUniqueKey()), formKey = _e[0], setFormKey = _e[1];
    var _f = useState(false), showError = _f[0], setShowError = _f[1];
    var _g = useState(false), visibleFields = _g[0], setVisibleFields = _g[1];
    var formRef = defaultFormRef || useRef(null);
    var _h = useFormValue(), _j = _h[0], values = _j.values, invalidFields = _j.invalidFields, validationMessages = _j.validationMessages, dispatch = _h[1];
    var _k = useChildClones(showError, visibleFields), renderChildren = _k[0], formFieldNameCounter = _k[1];
    var resetForm = function () {
        if (onReset) {
            onReset();
        }
        setFormKey(getUniqueKey());
    };
    var onFieldChange = function (field) {
        var _a, _b;
        var name = field.name, value = field.value, type = field.type, autoSubmit = field.autoSubmit, checked = field.checked;
        var valueIsArray = values[name] && Array.isArray(values[name]) && checked !== undefined;
        var newValue = value;
        // Handle checkboxes when they have array values
        if (type === 'Checkbox') {
            if (valueIsArray) {
                newValue = checked
                    ? __spreadArrays(values[name], [value]) : values[name].filter(function (item) { return item !== value; });
            }
            else if (formFieldNameCounter[name] > 1 && checked !== undefined) {
                newValue = [value];
            }
            else if (checked === false) {
                newValue = '';
            }
        }
        dispatch({ type: 'FORM_UPDATE', values: __assign(__assign({}, values), (_a = {}, _a[name] = newValue, _a)) });
        if (autoSubmit) {
            onSubmit();
        }
        if (onChange) {
            onChange({ name: name, value: newValue }, __assign(__assign({}, values), (_b = {}, _b[name] = newValue, _b)));
        }
    };
    var handleOnSubmit = function (e) {
        if (sendDataType === 'formdata' && typeof FormData === 'undefined') {
            return true;
        }
        if (e && !defaultSubmit) {
            e.preventDefault();
        }
        var index = null;
        var messages = __assign({}, validationMessages);
        var updatedInvalidFields = invalidFields;
        if (multiStep) {
            var _a = getStepFields(currentStep, id), formData = _a[0], stepIndex = _a[1], currentStepFields_1 = _a[2];
            setVisibleFields(currentStepFields_1);
            values = formData;
            index = stepIndex;
            updatedInvalidFields = invalidFields.filter(function (fieldId) {
                return currentStepFields_1.some(function (field) { return field.indexOf(fieldId) >= 0; });
            });
            messages = Object.keys(validationMessages)
                .filter(function (key) {
                return currentStepFields_1.some(function (field) { return field.indexOf(key) >= 0; });
            })
                .reduce(function (obj, key) {
                var _a;
                return __assign(__assign({}, obj), (_a = {}, _a[key] = validationMessages[key], _a));
            }, {});
        }
        else if (sendDataType === 'formdata') {
            values = new FormData(formRef.current);
        }
        if (updatedInvalidFields.length > 0) {
            setShowError(true);
        }
        if (onSubmit) {
            onSubmit(values, index, messages, updatedInvalidFields);
        }
    };
    return (React.createElement("form", { key: formKey, className: className, method: method, action: action, encType: enctype, onSubmit: handleOnSubmit, ref: formRef, id: id, noValidate: true, "data-name": dataName }, renderChildren(children, initialValues, resetForm, onFieldChange)));
};
export default Form;
